(() => {
  const openCart = () => {
    const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');

    if (trigger instanceof HTMLElement) {
      trigger.click();
      return;
    }

    window.location.href = window.Theme?.routes?.cart_url || '/cart';
  };

  document.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-cd-open-cart]') : null;
    if (!button) return;

    event.preventDefault();
    openCart();
  });

  const nodeText = (node) => (node.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  const headingKey = (text) => text.replace(/[^a-z0-9\s]/g, '').replace(/\s+/g, ' ').trim();
  const isIncludedHeading = (text) => headingKey(text).startsWith('whats included');
  const isDetailsHeading = (text) => headingKey(text).startsWith('product details');

  const splitProductEditorial = (root) => {
    const briefBody = root.querySelector('[data-cd-brief-body]');
    if (!briefBody) return;

    const includedWrap = root.querySelector('[data-cd-included]');
    const detailsWrap = root.querySelector('[data-cd-details]');
    const includedBody = root.querySelector('[data-cd-included-body]');
    const detailsBody = root.querySelector('[data-cd-details-body]');
    const includedFilled = root.getAttribute('data-cd-included-filled') === 'true';
    const detailsFilled = root.getAttribute('data-cd-details-filled') === 'true';

    let source = briefBody;
    if (briefBody.children.length === 1 && briefBody.children[0].children.length > 1) {
      source = briefBody.children[0];
    }

    let mode = 'brief';
    const nodes = Array.from(source.childNodes);

    nodes.forEach((node) => {
      if (node.nodeType !== Node.ELEMENT_NODE && node.nodeType !== Node.TEXT_NODE) return;

      const text = nodeText(node);
      const moveOrRemove = (filled, target) => {
        if (filled || !target) {
          node.remove();
          return;
        }
        target.appendChild(node);
      };

      if (!text) {
        if (mode === 'included') moveOrRemove(includedFilled, includedBody);
        else if (mode === 'details') moveOrRemove(detailsFilled, detailsBody);
        return;
      }

      if (isIncludedHeading(text)) {
        mode = 'included';
        node.remove();
        return;
      }

      if (isDetailsHeading(text)) {
        mode = 'details';
        node.remove();
        return;
      }

      if (mode === 'included') {
        moveOrRemove(includedFilled, includedBody);
        return;
      }

      if (mode === 'details') {
        moveOrRemove(detailsFilled, detailsBody);
      }
    });

    if (includedWrap && includedBody && (includedFilled || includedBody.innerHTML.trim())) {
      includedWrap.hidden = false;
    }

    if (detailsWrap && detailsBody && (detailsFilled || detailsBody.innerHTML.trim())) {
      detailsWrap.hidden = false;
    }

    const toggle = root.querySelector('[data-cd-brief-toggle]');
    if (!toggle) return;

    briefBody.classList.add('cd-product-brief__body--clamped');
    const syncToggle = () => {
      const overflowing = briefBody.scrollHeight > briefBody.clientHeight + 1;
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.hidden = !overflowing && !expanded;
      if (!overflowing && !expanded) {
        briefBody.classList.remove('cd-product-brief__body--clamped');
      }
    };

    requestAnimationFrame(syncToggle);
    window.addEventListener('resize', syncToggle, { passive: true });
  };

  const initProductEditorial = () => {
    document.querySelectorAll('[data-cd-product-editorial]').forEach((root) => {
      if (!(root instanceof HTMLElement) || root.dataset.cdReady === 'true') return;
      root.dataset.cdReady = 'true';
      splitProductEditorial(root);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target instanceof Element ? event.target.closest('[data-cd-brief-toggle]') : null;
    if (!toggle) return;

    event.preventDefault();
    const brief = toggle.closest('[data-cd-brief]');
    const body = brief?.querySelector('[data-cd-brief-body]');
    if (!body) return;

    const expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
    body.classList.toggle('cd-product-brief__body--clamped', expanded);
  });

  initProductEditorial();
  document.addEventListener('shopify:section:load', initProductEditorial);

  const isLocalThemePreview = () => {
    const host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost';
  };

  const hostedCheckoutOrigin = () => {
    if (window.cdShopOrigin) return String(window.cdShopOrigin).replace(/\/$/, '');
    if (window.Shopify?.shop) return `https://${window.Shopify.shop}`;
    return '';
  };

  const permalinkFromCart = async () => {
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (response.ok) {
        const cart = await response.json();
        const items = (cart.items || [])
          .filter((item) => item.variant_id && item.quantity > 0)
          .map((item) => `${item.variant_id}:${item.quantity}`);
        const discounts = (cart.discount_codes || [])
          .filter((entry) => entry.code && entry.applicable !== false)
          .map((entry) => entry.code);
        return { items, discounts };
      }
    } catch (error) {
      // Fall through to cart markup if the local proxy cannot serve cart.js.
    }

    const items = Array.from(document.querySelectorAll('.cart-items__table-row[data-key]'))
      .map((row) => {
        const variantId = String(row.getAttribute('data-key') || '').split(':')[0];
        const qtyInput = row.querySelector('.quantity-selector input, input[type="number"]');
        const quantity = Number(qtyInput?.value || 1);
        return variantId && quantity > 0 ? `${variantId}:${quantity}` : '';
      })
      .filter(Boolean);

    return { items, discounts: [] };
  };

  const permalinkFromProductForm = () => {
    const idInput = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"], product-form-component input[name="id"]'
    );
    if (!idInput?.value) return [];
    const qtyInput = document.querySelector(
      'form[data-type="add-to-cart-form"] input[name="quantity"], product-form-component input[name="quantity"]'
    );
    const quantity = Number(qtyInput?.value || 1) || 1;
    return [`${idInput.value}:${quantity}`];
  };

  const goToHostedCheckout = async () => {
    const origin = hostedCheckoutOrigin();
    if (!origin) return false;

    const { items, discounts } = await permalinkFromCart();
    const permalinkItems = items.length ? items : permalinkFromProductForm();
    if (!permalinkItems.length) {
      window.location.assign(`${origin}/checkout`);
      return true;
    }

    const url = new URL(`${origin}/cart/${permalinkItems.join(',')}`);
    if (discounts.length) url.searchParams.set('discount', discounts.join(','));
    window.location.assign(url.toString());
    return true;
  };

  const isCheckoutControl = (node) => {
    if (!(node instanceof Element)) return false;
    if (node.closest('#checkout, .cart__checkout-button, [name="checkout"]')) return true;
    if (node.closest('shopify-accelerated-checkout, shopify-accelerated-checkout-cart')) return true;

    const link = node.closest('a[href]');
    if (!link) return false;

    try {
      return new URL(link.getAttribute('href') || '', window.location.origin).pathname.startsWith('/checkout');
    } catch (error) {
      return false;
    }
  };

  if (isLocalThemePreview()) {
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target || !isCheckoutControl(target)) return;

        event.preventDefault();
        event.stopPropagation();
        goToHostedCheckout();
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const submitter = event.submitter;
        const isCheckoutSubmit =
          submitter instanceof HTMLElement &&
          (submitter.getAttribute('name') === 'checkout' ||
            submitter.id === 'checkout' ||
            submitter.classList.contains('cart__checkout-button'));
        if (!isCheckoutSubmit) return;

        event.preventDefault();
        event.stopPropagation();
        goToHostedCheckout();
      },
      true
    );
  }
})();

